import axios from "axios";
import * as actionTypes from "./actionTypes";
import {loginURL, registerURL, logoutURL} from "../../constants";
import {openNotificationWithIcon} from "../../containers/Function";
import Cookies from 'universal-cookie';

const cookies = new Cookies

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START
  };
};

export const authSuccess = token => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    token: token
  };
};

export const authFail = error => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error
  };
};

export const logout = () => {
  axios
    .get(logoutURL)
    .then(res => {
      // cookies.remove('token')
      // cookies.remove('refresh')

      console.log('Logout');
    })
    .catch(err => {

    });

  // localStorage.clear()
  // cookies.remove('inforHotNew')

  // Xóa toàn bộ cookies có thể do khởi tạo nhiều
  // document.cookie.split(";").forEach((c) => {
  //   document.cookie = c
  //     .replace(/^ +/, "")
  //     .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  // });
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};

export const checkAuthTimeout = expirationTime => {
  return dispatch => {
    setTimeout(() => {
      dispatch(logout());
    }, expirationTime * 1000);
  };
};

export const authLogin = (username, password) => {
  return dispatch => {
    dispatch(authStart());

    axios
      .post(loginURL, {
        username: username,
        password: password
      })
      .then(res => {
        const token = res.data.data.access;
        const refresh = res.data.data.refresh;
        const menu = JSON.stringify(res.data.ls_project);
        localStorage.setItem('menu',menu);

        cookies.set("token",token) // Huy sửa 03102022
        cookies.set("refresh",refresh) // Huy sửa 03102022

        // // 220525 Login r-talk
        // // Kiểm tra có tab R-Talk trong menu không, có mới login web r-talk
        // const data_rtalk = res.data.data_rtalk || {};
        // if (Object.keys(data_rtalk).length > 0) {
        //   const popup = window.open("https://r-talk-uat.rainscales.com.vn/auto-login.html", 'elementLogin', 'width=1,height=1,left=9999,top=9999');
        //   // Gửi dữ liệu token sang Element
        //   popup.onload = () => {
        //       popup.postMessage({
        //         type: 'element-login',
        //         data: data_rtalk
        //       }, 'https://r-talk-uat.rainscales.com.vn');
        //   };
        //   // const popup = window.open("https://r-talk-uat.rainscales.com.vn/auto-login.html", '_blank');
        //   // setTimeout(() => {
        //   //   popup.postMessage(data_rtalk, "https://r-talk-uat.rainscales.com.vn");
        //   // }, 1000);
        // }
        // // else {
        // //   console.log("Không có tokenData → không mở element");
        // // }

        // dispatch(getListService(res.data.ls_project));
        dispatch(checkAuthTimeout(3600));
        // 041224 Ko được đặt trên cookies.set("token",token), vì các logic gọi API hoặc xử lý trong Redux có thể đã xảy ra trước khi cookie được lưu nếu đặt nó sau dispatch.
        dispatch(authSuccess(token));
      })
      .catch(err => {
      console.log(err);

        if (err.request.status === 0) {
          openNotificationWithIcon('error','Lỗi kết nối','Lỗi kết nối, kiểm tra kết nối tới server !!!')
        }

         dispatch(authFail(err));
      });
  };
};

export const authSignup = (username, email, password1, password2) => {
  return dispatch => {
    dispatch(authStart());
    axios
      .post(registerURL, {
        username: username,
        email: email,
        password1: password1,
        password2: password2
      })
      .then(res => {
        const token = res.data.key;
        cookies.set("token", token);
        dispatch(authSuccess(token));
        dispatch(checkAuthTimeout(3600));
      })
      .catch(err => {
        dispatch(authFail(err));
      });
  };
};

export const authCheckState = () => {
  return dispatch => {
    const token = cookies.get("token");
    if (token === undefined) {
      dispatch(logout());
    } else {
        dispatch(authSuccess(token));
    }
  };
};

